"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "toast", {
  enumerable: true,
  get: function get() {
    return _reactToastify.toast;
  }
});
exports.notify = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactToastify = require("react-toastify");

require("react-toastify/dist/ReactToastify.css");

var _ToasterStyled = require("./Toaster-styled");

var _AlertStyled = require("../Alert/Alert-styled");

var _XIcon = _interopRequireDefault(require("calcite-ui-icons-react/XIcon"));

var _LightbulbIcon = _interopRequireDefault(require("calcite-ui-icons-react/LightbulbIcon"));

var _CheckCircleIcon = _interopRequireDefault(require("calcite-ui-icons-react/CheckCircleIcon"));

var _ExclamationMarkTriangleIcon = _interopRequireDefault(require("calcite-ui-icons-react/ExclamationMarkTriangleIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getAlertIcon = function getAlertIcon(type) {
  var defaultIcon;

  if (type === 'success') {
    defaultIcon = _react.default.createElement(_CheckCircleIcon.default, {
      filled: true,
      size: 16
    });
  } else if (type === 'warning' || type === 'error') {
    defaultIcon = _react.default.createElement(_ExclamationMarkTriangleIcon.default, {
      filled: true,
      size: 16
    });
  } else {
    defaultIcon = _react.default.createElement(_LightbulbIcon.default, {
      filled: true,
      size: 16
    });
  }

  return _react.default.createElement(_AlertStyled.StyledAlertIcon, null, defaultIcon);
}; // Wraps the content in a <ToastMessage /> component for styling
// if they only passed a string of content


var wrapContentMessage = function wrapContentMessage(content) {
  if (content && typeof content === 'string') {
    return _react.default.createElement(_AlertStyled.StyledAlertMessage, null, content);
  }

  return content;
};

var CloseButton = function CloseButton(_ref) {
  var closeToast = _ref.closeToast;
  return _react.default.createElement(_ToasterStyled.StyledCloseButton, {
    type: "button",
    iconButton: true,
    icon: _react.default.createElement(_XIcon.default, {
      size: 16
    }),
    onClick: closeToast
  });
};

var notify = function notify(content) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref2.type,
      showProgress = _ref2.showProgress,
      showIcon = _ref2.showIcon,
      toastId = _ref2.toastId,
      other = _objectWithoutProperties(_ref2, ["type", "showProgress", "showIcon", "toastId"]);

  var progressClassName = '';

  if (showProgress) {
    progressClassName = 'progress-visible';
  } else if (showProgress === false) {
    progressClassName = 'progress-hidden';
  }

  if (!toastId || !_reactToastify.toast.isActive(toastId)) {
    // If no ToastContainer has been mounted yet we can do that here
    if (!document.getElementsByClassName('Toastify')) {
      _reactToastify.toast.configure({
        className: 'calcite-react-toastify',
        closeButton: _react.default.createElement(CloseButton, null)
      });
    }

    toastId = (0, _reactToastify.toast)(_react.default.createElement(_ToasterStyled.StyledToaster, {
      type: type
    }, showIcon && getAlertIcon(type), _react.default.createElement(_AlertStyled.StyledAlertContent, null, wrapContentMessage(content))) || '', _objectSpread({
      progressClassName: progressClassName,
      type: type
    }, other));
  } // Returning toastId will allow users to access id of specific toaster, which will let them manipulate that specific toaster only, if desired.


  return toastId;
};

exports.notify = notify;

var Toaster =
/*#__PURE__*/
function (_Component) {
  _inherits(Toaster, _Component);

  function Toaster() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Toaster);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Toaster)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toastId", null);

    return _this;
  }

  _createClass(Toaster, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.warn('Depracation warning: Using <Toaster /> as a rendered component is deprecated. Please use notify(content, options). See https://calcite-react.netlify.com/toaster for more info.');

      var _this$props = this.props,
          children = _this$props.children,
          open = _this$props.open,
          other = _objectWithoutProperties(_this$props, ["children", "open"]);

      if (open) {
        notify(children, _objectSpread({
          toastId: this.toastId
        }, other));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          children = _this$props2.children,
          open = _this$props2.open,
          other = _objectWithoutProperties(_this$props2, ["children", "open"]);

      if (open) {
        notify(children, _objectSpread({
          toastId: this.toastId
        }, other));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Toaster;
}(_react.Component);

exports.default = Toaster;
Toaster.propTypes = {
  /** Components to be rendered within the Toaster. */
  children: _propTypes.default.node,

  /** Type of Toaster to render; affects the background color. */
  type: _propTypes.default.oneOf(['default', 'success', 'info', 'warning', 'error']),

  /** Position where the Toaster will be placed on the screen. */
  position: _propTypes.default.oneOf(['top-left', 'top-center', 'top-right', 'bottom-right', 'bottom-center', 'bottom-left']),

  /** How long the Toaster should be open for; false if it shouldn't auto close, or a duration in millisecnds for how long it should take to close. */
  autoClose: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),

  /** Toggle default visibility of the progress bar in a Toaster. */
  showProgress: _propTypes.default.bool,

  /** Toggles visibility of the icon */
  showIcon: _propTypes.default.bool
};
Toaster.defaultProps = {
  position: 'top-right',
  type: 'default',
  autoClose: 5000
};
Toaster.displayName = 'Toaster';